import React from "react";
import PropTypes from "prop-types";
import ChipsList from "./ChipsList";

import HomepageTitle from "arena/components/HomepageTitle";
import Box from "@mui/material/Box";
import { useQuery } from "@apollo/client";
import { ArenaIconsQuery } from "arena/queries";

const indexBy = (items) =>
  items.reduce((all, item) => {
    all[item.id] = item;
    return all;
  }, {});

/**
 * Список быстрых ссылок в виде чипов с иконками
 */
export default function ArenaFastLinksList({ title, items = [] }) {
  const iconIds = items
    .filter((item) => item.iconId)
    .map((item) => item.iconId);

  const { data } = useQuery(ArenaIconsQuery, {
    skip: !iconIds.length,
    variables: {
      ids: iconIds,
    },
  });

  if (!items.length) return null;

  const iconsById = indexBy(data?.icons || []);

  const listItems = items.map((item, index) => {
    return {
      id: index,
      title: item.title,
      url: item.url,
      icon: iconsById[item.iconId],
      openInNewWindow: item.openInNewWindow,
    };
  });

  return (
    <>
      {title ? <HomepageTitle title={title} /> : <Box sx={{ mt: 2 }} />}
      <ChipsList items={listItems} />
    </>
  );
}

ArenaFastLinksList.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      iconId: PropTypes.string,
      openInNewWindow: PropTypes.bool,
    })
  ),
};
